import { SelectOption } from 'ComponentLibrary/src/atoms/Select/Select'

export const LEASE_TYPE_LABELS = {
    free: 'Frei',
    graduated: 'Staffel',
    indexed: 'Index',
}

export const leaseTypeOptions: SelectOption[] = [
    { value: 'free', label: LEASE_TYPE_LABELS.free },
    { value: 'indexed', label: LEASE_TYPE_LABELS.indexed },
    { value: 'graduated', label: LEASE_TYPE_LABELS.graduated },
]

export const paymentScopeOptions: SelectOption[] = [
    { value: 'per_area', label: 'pro m²' },
    { value: 'per_unit', label: 'pro Einheit' },
    { value: 'absolute', label: 'Absolut' },
]

export const paymentPeriodOptions: SelectOption[] = [
    { value: 'monthly', label: 'Monatlich' },
    { value: 'yearly', label: 'Jährlich' },
]

export const costScopeOptions: SelectOption[] = [
    { value: 'per_unit', label: '€ pro Einheit' },
    { value: 'absolute', label: '€ Absolut' },
    { value: 'per_construction_cost', label: '% der Baukosten' },
    { value: 'per_yearly_rent', label: '% der Jahresmiete' },
    { value: 'per_area', label: '€ pro m²' },
    { value: 'per_monthly_rent', label: 'Anzahl Monatsmieten' },
]
